import firebase from '../../firebase.js';
import editImages from '../editImages/editImages.vue';
const db = firebase.firestore();
export default {
    name: 'Create',
    data() {
        return {
            title: '',
            body: '',
            postAddedSnackbar: false
        };
    },
    computed: {
        images() {
            return this.$refs.images.images;
        }
    },
    methods: {
        submit() {
            this.images.forEach(item => {
                delete item.imageDialog;
                delete item.dialog;
            });
            db.collection('/blogPosts').add({
                title: this.title,
                body: this.body,
                images: this.images,
                timestamp: firebase.firestore.FieldValue.serverTimestamp()
            });
            this.title = '';
            this.body = '';
            this.$refs.images.images = [];
            this.postAddedSnackbar = true;
        }
    },
    components: {
        editImages
    }
};



// WEBPACK FOOTER //
// ./src/components/create/create.js